import { createApp } from 'vue';
import pinia from '/@/stores/index';
import App from './App.vue';
import '/@common/fonts/font.scss';
import router from '/@/router';
import { directive } from '/@common/directive/index';
import { i18n } from '/@common/i18n/index';
import globalComponents from '/@common/components';

// 引入 3D 散点图组件
import { Scatter3DChart } from 'echarts-gl/charts'
import { Grid3DComponent } from 'echarts-gl/components'
// 引入 ECharts 核心模块
import { use } from 'echarts/core'

// 注册组件
use([
  Scatter3DChart,
  Grid3DComponent
])



import WinboxUI from 'winbox-ui-next';
import 'winbox-ui-next/dist/winbox.css';
import 'vant/lib/index.css'; // 提前全局引入vant样式，方便后续覆盖
import '/@common/theme/index.scss';
import '/@common/theme/lit.css';
import * as CoolBoxIcons from '@coolbox/we-design/dist/vue3/es.js';
import '@coolbox/we-design/style/index.css';
// import vantComponents from '/@common/components/h5/vant';
// import sentry from './sentry';
import * as CoolBoxIconsTilake from '@coolbox/tilake/dist/vue3/es.js';
import '@coolbox/tilake/style/index.css';

import 'animate.css';

import Vue3Lottie from 'vue3-lottie';

// h5
import '/@common/utils/h5plus/common';

const app = createApp(App);

for (const [key, component] of Object.entries(CoolBoxIcons)) {
	app.component(key + 'We', component);
}
for (const [key, component] of Object.entries(CoolBoxIconsTilake)) {
	app.component(key, component);
}

directive(app);
// vantComponents(app);
// sentry(app,router)


app.use(pinia).use(router).use(WinboxUI,{
  // 用于改变使用组件时的前缀名称
  componentPrefix: 'w'
}).use(i18n).use(globalComponents).use(Vue3Lottie).mount('#app');
